<template>
  <ul
    id="main-menu-navigation"
    class="nav navbar-nav menu-fixed menu-accordion menu-shadow"
    :key="updateKey"
    @mouseleave="onContainerLeave"
    @mouseenter="onContainerEnter"
  >
    <component
      :is="resolveNavComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import HorizontalNavMenuHeaderLink from "../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue";
import HorizontalNavMenuHeaderGroup from "../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue";
import { watch, ref, toRefs, provide, onBeforeUnmount } from "@vue/composition-api";


export default {
  components: {
    HorizontalNavMenuHeaderLink,
    HorizontalNavMenuHeaderGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    userData : {
      type: Object,
      required: false,
    }
  },
  setup(props) {
    const resolveNavComponent = (item) => {
      if (item.children) return "horizontal-nav-menu-header-group";
      return "horizontal-nav-menu-header-link";
    };

    const { userData } = toRefs(props);
     const updateKey = ref(0);

    watch(userData, (val) => {
        updateKey.value = updateKey.value + 1
    });

    // Provide a reactive signal to close all open dropdowns
    const closeAllTick = ref(0)
    provide('horizontalMenuControl', { closeAllTick })

    // Handle delayed close when leaving the main container
    let closeTimer = null
    const onContainerLeave = () => {
      if (closeTimer) clearTimeout(closeTimer)
      closeTimer = setTimeout(() => {
        closeAllTick.value += 1
        closeTimer = null
      }, 500)
    }

    const onContainerEnter = () => {
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
    }

    onBeforeUnmount(() => {
      if (closeTimer) clearTimeout(closeTimer)
    })

    return {
      resolveNavComponent,
      updateKey,
      onContainerLeave,
      onContainerEnter,
    };
  },
};
</script>
